import { define, html, store, router } from "hybrids";
import layout from "~/factories/layout";

import Broadcast from "~/stores/Broadcast";
import Session from "~/stores/Session";

import Chat from "./Chat";
import User from "./User";
import Share from "./Share";
import Donate from "./donate/Root";

export interface VBroadcastPeopleView {
  broadcast?: Broadcast;
  session: Session;
}

export default define<VBroadcastPeopleView>({
  [router.connect]: {
    stack: [Chat, User, Donate, Share],
  },
  tag: "v-broadcast-people-view",
  broadcast: store(Broadcast),
  session: store(Session),
  render: layout("flex"),
  content: ({ broadcast, session }) =>
    html`
      <v-broadcast-container>
        <v-broadcast-stats broadcast="${broadcast}"></v-broadcast-stats>
      </v-broadcast-container>
      <v-broadcast-container overflow>
        ${broadcast &&
        store.ready(broadcast, session) &&
        html`
          ${!!broadcast.course.collaborators.length &&
          html`
            <v-broadcast-people-section name="${broadcast.header}">
              ${broadcast.course.collaborators.map((user) =>
                html`<v-ui-link href="${router.url(User, { user })}" block>
                  <v-broadcast-user
                    user="${user}"
                    broadcast="${broadcast}"
                    details
                  ></v-broadcast-user>
                </v-ui-link>`.key(user.id)
              )}
            </v-broadcast-people-section>
            <v-broadcast-divider></v-broadcast-divider>
          `}
          ${!!broadcast.patrons.length &&
          html`
            <v-broadcast-people-section name="Patrons">
              ${broadcast.patrons
                .filter(({ user }) => !session.blockedUsers.includes(user))
                .map((patron) =>
                  html`<v-ui-link
                    href="${router.url(User, { user: patron.user })}"
                    block
                  >
                    <v-broadcast-user
                      user="${patron.user}"
                      broadcast="${broadcast}"
                      details
                    ></v-broadcast-user>
                  </v-ui-link>`.key(patron.user.id)
                )}
            </v-broadcast-people-section>
            <v-broadcast-divider></v-broadcast-divider>
          `}
        `}
      </v-broadcast-container>
    `,
});
